export const corporateClientColumns = [
    {
        name: "Company Name",
        selector: (row) => row["companyName"],
        sortable: true,
        center: true,
        grow: 2
    },
    {
        name: "Contact",
        selector: (row) => row["contactPerson"],
        sortable: true,
        center: true,
    },
    {
        name: "Mobile",
        selector: (row) => row["mobile"],
        sortable: true,
        center: true,
    },
    {
        name: "Email",
        selector: (row) => row["email"],
        sortable: true,
        center: true,
        grow: 3
    },
    // {
    //     name: "Address",
    //     selector: (row) => row["addressLine"],
    //     sortable: true,
    //     center: true,
    // },
    {
        name: "City",
        selector: (row) => row["city"],
        sortable: true,
        center: true,
    },
    {
        name: "MegaCabsCompany",
        selector: (row) => row["isMegaCabsCompany"],
        sortable: true,
        center: true,
    },
    {
        name: "Created On",
        selector: (row) => row["createdOn"],
        sortable: true,
        center: true,
    },
    {
        name: "Airport Charge",
        selector: (row) => row["airportCharge"],
        sortable: true,
        center: true,
    },
    {
        name: "AirportToCity",
        selector: (row) => row["a2c"],
        sortable: true,
        center: true,
    },
    {
        name: "CityToAirport",
        selector: (row) => row["c2a"],
        sortable: true,
        center: true,
    },
    {
        name: "",
        cell: (row) => row["action"],
        sortable: true,
        center: true,
        width: "30px",
      },
];

export const CorporateClientFilterColumns = [
    {
        name: "AIRPORT TO CITY",
        value: "a2c",
        type: "boolean",
    },
    {
        name: "CITY TO AIRPORT",
        value: "c2a",
        type: "boolean",
    }
];

export const CorporateClientFilterColumnsNew = [
    {
        name: "Ride Type",
        value: "pickup_type",
        type: "select",
    },
    {
        name: "Client Type",
        value: "client_type",
        type: "select",
    }
];